
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"78","height":"74","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(0 4)","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M73.501 19.271c2.47.216 4.318 2.36 4.108 4.765L74.057 64.64c-.21 2.405-2.403 4.196-4.873 3.98L4.499 62.96C2.029 62.744.18 60.6.39 58.196L3.943 17.59c.21-2.405 2.403-4.195 4.873-3.98l64.685 5.66zM39.932 54.355l-31.07-2.718-.432 4.935L39.5 59.29l.432-4.935zm23.32-4.495a5.635 5.635 0 00-3.196.665 5.633 5.633 0 00-3.032-1.21c-3.123-.273-5.878 2.047-6.152 5.18-.275 3.135 2.036 5.897 5.16 6.17 1.15.101 2.25-.15 3.195-.664a5.644 5.644 0 003.032 1.21c3.123.273 5.878-2.046 6.152-5.181.274-3.134-2.036-5.897-5.159-6.17zM29.88 44.454L9.835 42.7l-.432 4.935 20.045 1.754.432-4.935z","fill":"#EDEDF4","fill-rule":"nonzero"}}),_c('ellipse',{attrs:{"stroke":"#FFF","stroke-width":"3.966","fill":"#EDEDF4","cx":"38.961","cy":"17.09","rx":"19.338","ry":"19.073"}}),_c('path',{attrs:{"d":"M39.97 7.43a.5.5 0 01.5.5v7.674h7.8a.5.5 0 01.5.5v2.468a.5.5 0 01-.5.5h-7.8v7.674a.5.5 0 01-.5.5h-2.522a.5.5 0 01-.5-.5v-7.674h-7.8a.5.5 0 01-.5-.5v-2.468a.5.5 0 01.5-.5h7.8V7.93a.5.5 0 01.5-.5h2.522z","fill":"#FFF"}})])])
          )
        }
      }
    